import { render, staticRenderFns } from "./RemovalToggleListItem.vue?vue&type=template&id=1b9fb587&scoped=true"
import script from "./RemovalToggleListItem.vue?vue&type=script&lang=js"
export * from "./RemovalToggleListItem.vue?vue&type=script&lang=js"
import style0 from "./RemovalToggleListItem.vue?vue&type=style&index=0&id=1b9fb587&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9fb587",
  null
  
)

export default component.exports